import { Button, ButtonVariants } from '@components/button/Button';
import { Modal } from '@components/modal/Modal';
import { ModalActions } from '@components/modal/ModalActions';
import typography from '~styles/typography.scss';
import styles from './EditListingModals.scss';

interface EditListingWarningModalProps {
  isOpen: boolean;
  closeModal: () => void;
  warnings?: string[];
  confirm: () => void;
}

export const EditListingWarningModal = ({
  isOpen,
  closeModal,
  warnings,
  confirm,
}: EditListingWarningModalProps) => (
  <Modal isOpen={isOpen} onClose={closeModal} title="Edit Listing Warnings">
    <div className={styles.modalContent}>
      {warnings?.map((warning) => (
        <p key={warning} className={typography.c2}>
          {warning}
        </p>
      ))}
      <ModalActions>
        <Button
          label="Cancel"
          onClick={closeModal}
          variant={ButtonVariants.Tertiary}
        />
        <Button
          label="Save And Unassign"
          onClick={confirm}
          variant={ButtonVariants.Tertiary}
        />
      </ModalActions>
    </div>
  </Modal>
);
